

var Airtable = require('airtable')

var base = new Airtable({apiKey: 'keyjdntarZ4sFlNpW'}).base('apppkkrVuIBYcBtbb');

export const getDataSet = (callback) => { // event, context, callback
  
  try {

    // The response data object
    var data = {
      partijen:  [],
      projecten: [],      
      themas: []
    };

    // Report when all calls have been completed
    var status = 0;
    var doneHandler = (err) => {
      if (err) { 
        console.error(err); 
      } else {
        status++;
        if (status === 3) { 
          callback(null, {
            statusCode: 200,
            body: JSON.stringify(data, null, 4)
          });
        }
      }
    }

    // Projecten...
    base('Projecten').select()
    .eachPage(function page(records, fetchNextPage) {
      records.forEach(function(record) {
          data.projecten.push({
            id: record.id,
            name: record.get('Name'), 
            slug: record.get('Slug'),
            verhaal: record.get('Verhaal'), // WYSIWYG field - zie Woonplan
            plaats: record.get('Plaats'),
            ambitie: record.get('Renovatie Ambitie'),
            indienenrv: record.get('Indienen RV'),
            image: record.get('Afbeelding'),
            video: record.get('Video url'),
            themas: record.get('Tags'),
            partijen: record.get('Partijen'),
            sgds: record.get('SDGs'),
            location: {
              lat: record.get('Lat'), 
              lng: record.get('Lng')
            }
          }) 
      });
      fetchNextPage();
    }, doneHandler);


    // Themas
    base('Tags').select()
    .eachPage(function page(records, fetchNextPage) {
      records.forEach(function(record) {

        // If no verhalen => ignore...
        if (record.get('Projecten')) {
          data.themas.push({
            id: record.id,
            name: record.get('Name'),
            slug: record.get('Slug'),
            summary: record.get('Notes'),
            category: record.get('Type')
          })
        }
      });
      fetchNextPage();
    }, doneHandler);
    
    // Partijen
    base('Partijen').select()
    .eachPage(function page(records, fetchNextPage) {
      records.forEach(function(record) {
        // If no verhalen => ignore...
        if (record.get('Projecten')) {
          data.partijen.push({
            id: record.id,
            name: record.get('Name'),
            slug: record.get('Slug'),
            summary: record.get('Notes'),
            type: record.get('Type')
          }) 
        }
      });
      fetchNextPage();
    }, doneHandler);

  } catch (err) {
    console.log(err); // output to netlify function log
    callback(null, {
      statusCode: 500,
      body: JSON.stringify({ msg: err.message }) // Could be a custom message or object i.e. JSON.stringify(err)
    });
  }
}